import { Component, HostListener, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Observable, of } from "rxjs";
import { PopupButton } from "../../models/popup-enums";
import { PopupInformation } from "../../models/popup-information";
import { PopupService } from "../../services/popup.service";

@Component({
  standalone: false,
  selector: "dua-popup",
  templateUrl: "./popup.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./popup.component.scss"],
})
export class PopupComponent implements OnInit {
  popupInformation!: PopupInformation;
  show!: boolean;

  showCancel!: boolean;
  showOk!: boolean;
  showYes!: boolean;
  showNo!: boolean;
  showYesDisabled!: boolean;

  PopupButton = PopupButton;

  private closing = false;

  constructor(private popupService: PopupService) {}

  ngOnInit(): void {
    this.popupService.shouldShow.subscribe((show) => {
      this.show = show;

      if (show) {
        this.closing = false;
        this.popupInformation = this.popupService.getCurrentPopup();
        this.evaluateButtonVisibility();
      }
    });
  }

  close(buttonPressed: PopupButton) {
    if (this.closing) {
      return;
    }
    this.closing = true;

    let callback: Observable<unknown> = of({});

    switch (buttonPressed) {
      case PopupButton.Ok:
        callback = this.popupService.okCallback?.() ?? of({});
        break;
      case PopupButton.Yes:
        callback = this.popupService.yesCallback?.() ?? of({});
        break;
      case PopupButton.No:
        callback = this.popupService.noCallback?.() ?? of({});
        break;
      case PopupButton.Cancel:
        callback = this.popupService.cancelCallback?.() ?? of({});
        break;
      default:
        break;
    }

    callback.subscribe({
      next: () => this.hideDialog(),
      error: () => this.hideDialog(),
    });
  }

  @HostListener("document:keydown.escape")
  onEscape() {
    if (this.show) {
      this.onDialogHide();
    }
  }

  onDialogHide() {
    this.hideDialog();
  }

  private hideDialog() {
    this.show = false;
    this.popupService.hidePopup();
    this.popupService.resetCallbacks();
    this.popupService.resetErrorMessages();
    this.closing = false;
  }

  evaluateButtonVisibility() {
    const buttons = this.popupInformation?.buttons ?? [PopupButton.Ok];

    this.showCancel = buttons.includes(PopupButton.Cancel);
    this.showOk = buttons.includes(PopupButton.Ok);
    this.showYes = buttons.includes(PopupButton.Yes);
    this.showNo = buttons.includes(PopupButton.No);
    this.showYesDisabled = buttons.includes(PopupButton.YesDisabled);

    // Error (and any misconfigured) popups must always be dismissible.
    if (!this.showCancel && !this.showOk && !this.showYes && !this.showNo) {
      this.showOk = true;
    }
  }
}
